<template>
  <section>
    <b-row class="flex-wrap px-50 pb-1">
      <b-col
        lg="3"
        sm="6"
        cols="6"
        class="d-flex px-50 pt-0"
        v-for="(card, index) in cards"
        :key="index"
      >
        <wallet-statistics
          class="w-100"
          :info="card"
          :loading="loading"
          :statistics="statistics"
        />
      </b-col>
    </b-row>
    <b-row class="px-50 pb-1">
      <b-col class="d-flex w-100">
        <b-card no-body class="w-100 p-md-2 p-1 overflow-auto">
          <div class="d-flex">
            <div class="mx-50">
              <b-button
                class="py-1"
                :class="[{ 'gradient-btn ': $route.name.includes('overview') }]"
                @click="$router.push(calRoute('overview'))"
              >
                Overview
              </b-button>
            </div>
            <div class="mx-50">
              <b-button
                class="py-1"
                :class="[{ 'gradient-btn ': $route.name.includes('deposit') }]"
                @click="$router.push(calRoute('deposit'))"
              >
                Deposit
              </b-button>
            </div>
            <div class="mx-50">
              <b-button
                class="py-1"
                :class="[{ 'gradient-btn ': $route.name.includes('withdraw') }]"
                @click="$router.push(calRoute('withdraw'))"
              >
                Withdraw
              </b-button>
            </div>

            <div class="mx-50">
              <b-button
                class="py-1"
                :class="[
                  { 'gradient-btn ': $route.name.includes('transactions') },
                ]"
                @click="$router.push(calRoute('transactions'))"
              >
                Transactions
              </b-button>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="px-50 pb-md-4 pb-2">
      <b-col class="d-flex w-100">
        <Transition mode="out-in">
          <router-view v-bind="bind" class="w-100" />
        </Transition>
      </b-col>
    </b-row>

    <b-row class="px-1 pb-1">
      <b-col cols="12" class="px-50 pb-md-3 pb-2">
        <span class="bottom-line h3 pb-75">Accepted Payment Methods</span>
      </b-col>
      <b-col
        lg="2"
        xl="1"
        sm="3"
        cols="3"
        class="p-50"
        v-for="(logo, index) in logos"
        :key="index"
      >
        <div
          class="bg-secondary h-100 rounded d-flex align-items-center justify-content-center p-50"
          style="height: 60px"
        >
          <b-img fluid :src="logo" style="max-height: 60px" />
        </div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol, BCard, BImg, BButton } from "bootstrap-vue";
import WalletStatistics from "./WalletStatistics.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BImg,
    BButton,
    WalletStatistics,
  },
  data() {
    return {
      loading: false,
      statistics: {},
      cards: [
        {
          img: "money.png",
          description: "Current balance",
          key: "current_balance",
          class: "bg-total-lost",
          color: "#D3435D",
        },
        {
          img: "done-all.png",
          description: "Total deposit",
          key: "total_deposit",
          class: "bg-total-won",
          color: "#FBAD25",
        },
        {
          img: "money_1.png",
          description: "Total withdraw",
          key: "total_withdraw",
          class: "bg-competitions-count",
          color: "#39A4F8",
        },
        {
          img: "earnings.png",
          description: "Total earnings",
          key: "total_earnings",
          class: "bg-tickets",
          color: "#25ECFB",
        },
      ],
      logos: [
        require("@/assets/images/fxlegends/UnionPay_logo.svg.png"),
        require("@/assets/images/fxlegends/Stripe_logo,_revised_2016.png"),
        require("@/assets/images/fxlegends/amexlogopng-1578907833580.png"),
        require("@/assets/images/fxlegends/Visa_Inc._logo.svg.png"),
        require("@/assets/images/fxlegends/Maestro_logo.png"),
        require("@/assets/images/fxlegends/diners-1.png"),
        require("@/assets/images/fxlegends/MasterCard-Logo-1990.png"),
        require("@/assets/images/fxlegends/Google-Pay-Logo.png"),
        require("@/assets/images/fxlegends/tether-1.svg"),
        require("@/assets/images/fxlegends/The-Japanese-payment-system-JCB-has-suspended-work-in-the.jpeg"),
        require("@/assets/images/fxlegends/Apple-Pay-Logo-0٣.png"),
        require("@/assets/images/fxlegends/discover-network-vector-logo.png"),
      ],
    };
  },
  computed: {
    bind() {
      return this.$route.name.includes("overview")
        ? {
            statistics: this.statistics,
            loadingStatistics: this.loading,
          }
        : "";
    },
  },
  watch: {
    $route: {
      async handler(val) {
        if (this.$route.query["notification[message]"]) {
          await this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: this.$route.query["notification[message]"],
                icon: "CoffeeIcon",
                variant: "success",
              },
            },
            { position: "bottom-right", timeout: 4000 }
          );
          this.$router.replace({ name: "wallet-overview" });
        }
        this.getWallet();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    calRoute(path) {
      return this.$route.name.includes("competition")
        ? {
            name: `competition-wallet-${path}`,
            params: { name: this.$route.params.id },
          }
        : this.$route.name.includes("user")
        ? {
            name: `user-wallet-${path}`,
            params: { name: this.$route.params.id },
          }
        : this.$route.name.includes("partner")
        ? {
            name: `partner-wallet-${path}`,
            params: { name: this.$route.params.id },
          }
        : this.$route.name.includes("plan")
        ? {
            name: `plan-wallet-${path}`,
            params: { name: this.$route.params.id },
          }
        : {
            name: `wallet-${path}`,
          };
    },
    calApiRoute(path) {
      return this.$route.name.includes("competition")
        ? `/panel/competitions/${this.$route.params.id}/${path}`
        : this.$route.name.includes("user")
        ? `/panel/users/${this.$route.params.id}/${path}`
        : this.$route.name.includes("partner")
        ? `/panel/partners/${this.$route.params.id}/${path}`
        : this.$route.name.includes("plan")
        ? `/panel/plans/${this.$route.params.id}/${path}`
        : `/panel/profile/user/${path}`;
    },
    async getWallet() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(this.calApiRoute("wallet"));
        this.statistics = data.data ? data.data : data;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.v-enter-active,
.v-leave-active {
  transition: all 0.4s ease;
}

.v-enter-from,
.v-leave-to {
  transform: scale(1.1);
  opacity: 0;
}
</style>
